import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { delay } from "rxjs/operators";
import { GridLayout } from "../../../insa-models/grid-layout.model";

@Injectable()
export class GridLayoutService {

    constructor() {
        this.createLayout = this.createLayout.bind(this);
        this.updateLayout = this.updateLayout.bind(this);
        this.readLayouts = this.readLayouts.bind(this);
        this.deleteLayout = this.deleteLayout.bind(this);
    }

    private saveToLocalStorage(gridName, metadataName, layout) {
        const layouts = this.loadFromLocalStorage(gridName, metadataName) || [];
        layouts.push(layout)
        const key = `${gridName}/${metadataName}/layouts`;
        localStorage.setItem(key, JSON.stringify(layouts));
        return true
    }

    private UpdateToLocalStorage(gridName, metadataName, layout) {
        let layouts = this.loadFromLocalStorage(gridName, metadataName) || [];
        layouts = layouts.filter(p => p.name !== layout.name)
        layouts.push(layout)
        const key = `${gridName}/${metadataName}/layouts`;
        localStorage.setItem(key, JSON.stringify(layouts));
        return true
    }

    private loadFromLocalStorage(gridName, metadataName) {
        const key = `${gridName}/${metadataName}/layouts`;
        const layouts = JSON.parse(localStorage.getItem(key)) || [];
        return layouts
    }

    private deleteFromLocalStorage(gridName, metadataName, layoutName) {
        let layouts = this.loadFromLocalStorage(gridName, metadataName);
        layouts = layouts.filter(t => t.name !== layoutName);
        const key = `${gridName}/${metadataName}/layouts`;
        localStorage.setItem(key, JSON.stringify(layouts));
        return true
    }

    createLayout(gridName: string, metadataName: string, layout: GridLayout) {
        const req = of(this.saveToLocalStorage(gridName, metadataName, layout)).pipe(delay(1500));
        return req
    }
    
    readLayouts(gridName: string, metadataName: string) {
        const req = of(this.loadFromLocalStorage(gridName, metadataName)).pipe(delay(1500)) as Observable<GridLayout[]>;
        return req
    }

    updateLayout(gridName: string, metadataName: string, layout: GridLayout) {
        const req = of(this.UpdateToLocalStorage(gridName, metadataName, layout)).pipe(delay(1500));
        return req
    }

    deleteLayout(gridName: string, metadataName: string, layoutName: string) {
        const req = of(this.deleteFromLocalStorage(gridName, metadataName, layoutName)).pipe(delay(1500));
        return req
    }
}


// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/generic-grid/gird-layout.service.ts